// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2hZ8C","colMaxWidth":"Table_colMaxWidth__G04Ey"};